import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountResponse } from 'src/app/models/account.model';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';
import { TransferTokenService } from 'src/app/services/transfer-token.service';

export interface Branch {
  code: number;
  name: string;
}

export interface BamTransaction {
  date: string;
  IdSubCategory: string;
  mov_type: string;
  sequential: number;
  concept: string;
  cashAmount: number;
  transactionDescription: string;
  check: string;
  debitAmount: number;
  Category_Name: string;
  branch: Branch;
  reference: string;
  IdCategory: string;
  datetime: string;
  localCheckAmount: number;
  summable: number;
  SubCatDesc: string;
  availableAmount: number;
  time: string;
  IdMovementF: string;
  ownCheckAmount: string;
  foreignCheckAmount: number;
  creditAmount: number;
}

@Component({
  selector: 'app-bam-query-movements',
  templateUrl: './bam-query-movements.component.html',
  styleUrls: ['./bam-query-movements.component.scss']
})
export class BamQueryMovementsComponent implements OnInit {
  accounts: AccountResponse[] = [];
  filterAccounts: AccountResponse[] = [];
  selectedOwnAccount: string | null = null;
  startDate = new Date().toLocaleDateString('en-CA');
  endDate = new Date().toLocaleDateString('en-CA');
  startDateTemp: string | null = new Date().toLocaleDateString('en-CA');
  endDateTemp: string | null = new Date().toLocaleDateString('en-CA');
  accountNumberTemp: string | null = null;
  paginationApplications: SimplePaginationModel = new SimplePaginationModel(0, 5, 0, 0, 0);
  movements: BamTransaction [] = [];
  sizes = [5, 10, 25, 50, 100];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  loading = false;
  loadingVoucher: { [key: number]: boolean } = {};

  confirmModalVisible = false;
  showInputCode = false;
  loadingSendCode = false;
  code2fa = '';
  movementPreview: any = null;

  constructor(private toastService: ToastrService, private accountService: AccountService, private bamTransferService: BamTransferServiceService, private transferTokenService: TransferTokenService) { }

  ngOnInit(): void {
    this.getBanksOwn();
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts.filter(account => account.bank == 4);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getMovements() {
    if (!this.selectedOwnAccount) {
      return;
    }

    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    const isValid = this.validateDateRange(this.startDate, this.endDate);

    if (!isValid) {
      this.toastService.warning('El rango de fechas no puede ser mayor a 31 días');
      return;
    }

    this.paginationApplications.page = 0;

    const data = {
      bankAccountNumber: this.selectedOwnAccount,
      initDate: this.startDate,
      endDate: this.endDate,
      limit: 0,
      offset: 0,
      token: this.code2fa
    }

    this.loading = true;
    this.bamTransferService.getAccountMovement(data).subscribe({
      next: (response: ResponseObject) => {
        this.movements = response.data.movements ?? [];
        this.startDateTemp = this.startDate;
        this.endDateTemp = this.endDate;
        this.accountNumberTemp = this.selectedOwnAccount;
        this.resetPagination();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener movimientos");
        this.loading = false;
      }
    });
  }

  resetPagination() {
    var newPosition = this.pagination.pageSize*this.pagination.pageIndex;
    this.pagination.total = this.movements;
    this.pagination.filter = this.movements.slice(newPosition, newPosition + this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  searching() {
    // this.pagination.total = this.movements.filter((vendor) => {
    //   return vendor.id + '' == this.searchVendor || vendor.nit.includes(this.searchVendor) || vendor.name.toLowerCase().includes(this.searchVendor.toLowerCase())
    // });
    // this.pagination.pageIndex = 0;
    // this.pagination.startElement = 0;
    // this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    // this.pagination.lastElement = this.pagination.filter.length;
  }

  validateDateRange(startDate: string, endDate: string): boolean {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = end.getTime() - start.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays <= 31;
  }

  // getPaginationMovements() {
  //   if (!this.selectedOwnAccount) {
  //     return;
  //   }
  //   console.log(this.paginationApplications);

  //   const isValid = this.validateDateRange(this.startDate, this.endDate);

  //   if (!isValid) {
  //     this.toastService.warning('El rango de fechas no puede ser mayor a 31 días');
  //     return;
  //   }

  //   const data = {
  //     bankAccountNumber: this.selectedOwnAccount,
  //     initDate: this.startDate,
  //     endDate: this.endDate,
  //     limit: this.paginationApplications.size,
  //     offset: this.paginationApplications.page*this.paginationApplications.size
  //   }

  //   this.loading = true;
  //   this.bamTransferService.getAccountMovement(data).subscribe({
  //     next: (response: ResponseObject) => {
  //       this.movements = response.data.movements ?? [];
  //       this.movements = this.movements.reverse();

  //       this.paginationApplications.total = response.data.total;
  //       var position = response.data.offset * response.data.limit;
  //       this.paginationApplications.start = position + 1;
  //       this.paginationApplications.end = position + this.movements.length;

  //       this.loading = false;
  //     },
  //     error: (error: HttpErrorResponse) => {
  //       this.toastService.error("Error al obtener movimientos");
  //       this.loading = false;
  //     }
  //   });
  // }

  getVoucher(voucherNumber: string, sequential: number) {
    if (!this.accountNumberTemp || !this.startDateTemp || !this.endDateTemp) {
      return;
    }
    const data = {
      bankAccountNumber: this.accountNumberTemp,
      initDate: this.formatDate(this.startDateTemp),
      endDate: this.formatDate(this.endDateTemp),
      operationList: [voucherNumber],
    }

    this.loadingVoucher[sequential] = true;
    this.bamTransferService.getVoucher(data).subscribe({
      next: (response) => {
        this.loadingVoucher[sequential] = false;
        const blob = response.body!;

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'voucher.pdf';
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener voucher")
        this.loadingVoucher[sequential] = false;
      }
    });
  }

  formatDate(dateStr: string): string {
    return dateStr.split('T')[0];
  }

  openConfirmModal() {
    if (!this.selectedOwnAccount) {
      this.toastService.error('Debes seleccionar una cuenta bancaria');
      return;
    }

    const isValid = this.validateDateRange(this.startDate, this.endDate);

    if (!isValid) {
      this.toastService.warning('El rango de fechas no puede ser mayor a 31 días');
      return;
    }

    const account = this.filterAccounts.find(
      acc => String(acc.accountNumber) === String(this.selectedOwnAccount)
    );

    this.movementPreview = {
      startDate: this.startDate,
      endDate: this.endDate,
      account
    };

    this.confirmModalVisible = true;
  }

  onConfirmSearch() {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    this.confirmModalVisible = false;
    this.getMovements();
  }

  onCancelSearch() {
    this.confirmModalVisible = false;
    this.resetTokenState();
  }

  sendRequestCode() {
    this.loadingSendCode = true;

    this.transferTokenService.createTokenTransfer().subscribe({
      next: (_response: ResponseObject) => {
        this.showInputCode = true;
        this.loadingSendCode = false;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al solicitar token');
        this.loadingSendCode = false;
      }
    });
  }

  async pastClipboard() {
    try {
      this.code2fa = await navigator.clipboard.readText();
    } catch (error) {
      console.error('No se pudo leer el portapapeles', error);
      this.toastService.error('No se pudo leer el portapapeles');
    }
  }

  resetTokenState() {
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }
}
